import { NgModule } from '@angular/core';
import { FullScreenHeightDirective } from './full-screen-height.directive';

@NgModule({
	declarations: [FullScreenHeightDirective],
	imports: [],
	exports: [FullScreenHeightDirective],
})
export class FullScreenHeightModule {}
